import React from 'react';
import {
    Card, CardBody, Progress,  FormText
} from 'reactstrap';


import NotificationSystem from 'react-notification-system';
 import {connect} from "react-redux";
import {alertActions} from "../../_actions";
import { appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";
import {commonService} from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
 import PageEmptyContent from "../utils/page.empty-content";
 import UnmatchedRecords from "./unmatched-records";
//Icons
 import PaymentIcon from 'react-icons/lib/md/payment';


const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class UnmatchedPaymentViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unmatchedPayments: [],
            modal: false,
            modalClass: '',
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            currentPage: 1,
            pageSize: 10,
            totalUnmatchPaymentsCount: 0
         };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.fetchUnmatchedPayments();
    }

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        this.setState(currState);
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    fetchUnmatchedPayments = (pageNumber) => {
        this.setState({contentError: false});
        const {dispatch} = this.props;
        let { pageSize } = this.state;

        let fromIndex;

        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            fromIndex = 0;
            pageNumber = 1;
        }else{
            fromIndex = pageSize * (pageNumber -1);
            dispatch(apiActions.startRequest());

        }

         let payload = { PageSize: 10, From: fromIndex};
        payload.Parameter = {PaymentStatus: 411};

        commonService.getUnmatchPayments(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({currentPage: pageNumber, unmatchedPayments: res.response.Results[0].Reconciliations, totalUnmatchPaymentsCount: res.response.TotalCount });
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });
    };
    render() {
         const { requesting } = this.props;
        const { pageRequesting } = this.props;
        const { contentError, unmatchedPayments, pageSize, currentPage, totalUnmatchPaymentsCount, } = this.state;
        let unmatchedPaymentsLength = unmatchedPayments.length;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress animated striped color="success" value={100} className="mb-2"/> }

                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                             <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                             <CardBody className="table-responsive">
                            <div className="row">
                                <h6 className="mb-4 col-md-8 text-uppercase pull-left">Unmatched Payments
                                    <FormText color="muted">
                                        {
                                            (unmatchedPaymentsLength > 0) &&
                                            <div>
                                                <PaymentIcon size="18" color="#43a8df"/>&nbsp;
                                                <span>{ totalUnmatchPaymentsCount }&nbsp;
                                                    { (totalUnmatchPaymentsCount === 1) ? 'unmatched payment' : 'unmatched payments' }
                                                 </span>
                                            </div>
                                        }
                                    </FormText>
                                </h6>
                            </div>


                            {(!pageRequesting &&  unmatchedPaymentsLength > 0) &&
                              <UnmatchedRecords data={ unmatchedPayments} pageSize={pageSize} currentPage={currentPage} totalUnmatchPaymentsCount={totalUnmatchPaymentsCount} pageDataCallBack={this.fetchUnmatchedPayments}/>
                            }

                            {(!pageRequesting && unmatchedPaymentsLength === 0) &&
                                <PageEmptyContent message='No unmatch payment!'/>
                            }
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
     return {
        loggingIn,
        requesting,
        pageRequesting,
    };
}
export default connect(mapStateToProps)(UnmatchedPaymentViewContent);



// WEBPACK FOOTER //
// ./src/views/unmatchedPayment/view-content.js